import React from "react";

const RolesPermissions = () => {
    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Roles & Permissions</h5>
                            <button className="btn btn-primary btn-sm">
                                Add Role +
                            </button>
                        </div>

                        <div className="card-body">
                            <div className="text-center text-muted py-5">
                                <h6>No roles configured yet</h6>
                                <p className="mb-0">
                                    Roles and permission settings will appear here once configured.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default RolesPermissions;
